import { pathToRegexp } from "path-to-regexp";
/**
 *
 * @param ownersMap a map of routes to owners (required)
 * @param pathname the path to find the owner for (required)
 * @param hash the hash to find the owner for (optional)
 * @returns an object containing the owner and displayOwner
 * @param displayOwnersMap a map of owners to display names (optional)
 */
export const findOwnerForRoute = ({ ownersMap, pathname, displayOwnersMap = {}, hash, }) => {
    var _a;
    const fullPath = hash ? `${pathname}${hash}` : pathname;
    let closestMatch = null;
    let currentHighestMatchingSegments = -1;
    Object.keys(ownersMap !== null && ownersMap !== void 0 ? ownersMap : {}).forEach((path) => {
        const keys = [];
        // check if there's a strict/exact match (1-1)
        const exactMatchRegex = pathToRegexp(path, keys, { end: true });
        const exactMatch = exactMatchRegex.exec(fullPath);
        // check if there's a partial/closest match
        const partialMatchRegex = pathToRegexp(path, keys, { end: false });
        const partialMatch = partialMatchRegex.exec(fullPath);
        // if theres a strict match (best match) - use it
        // otherwise use the partial/fallback match
        const match = exactMatch !== null && exactMatch !== void 0 ? exactMatch : partialMatch;
        if (match) {
            let hashPart = null;
            // Favour routes with more matching segments over wildcard routes
            // Noting if the route has a hash
            const matchingSegments = path
                .split("/")
                .map((part) => {
                if (part.includes("#")) {
                    hashPart = part.split("#")[1];
                }
                return part.endsWith("*") ? 1 : 2;
            })
                .reduce((a, b) => a + b);
            if (matchingSegments > currentHighestMatchingSegments) {
                currentHighestMatchingSegments = matchingSegments;
                closestMatch = path;
            }
            // If the number of matching segments is the same, favour the route with the hash
            if (matchingSegments === currentHighestMatchingSegments && hashPart) {
                closestMatch = path;
            }
        }
    });
    const owner = closestMatch && ownersMap && ownersMap[closestMatch] !== undefined ? ownersMap[closestMatch] : "unknown";
    return {
        owner,
        displayOwner: (_a = displayOwnersMap[owner]) !== null && _a !== void 0 ? _a : owner,
    };
};
